import { i18nKeys } from '@/src/utils/i18n.utils';
import { Select, SelectProps } from '@amzn/awsui-components-react';
import { OptionDefinition } from '@amzn/awsui-components-react/polaris/internal/components/option/interfaces';
import { NonCancelableEventHandler } from '@amzn/awsui-components-react/polaris/internal/events';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SelectInput.module.scss';

interface SelectInputProps {
  label: string;
  selectedOption?: OptionDefinition;
  placeholder: string;
  options: SelectProps.Option[];
  onChange: NonCancelableEventHandler<SelectProps>;
  allowNone?: boolean;
  'data-testid'?: string;
}

export const SelectInput: React.FC<SelectInputProps> = (props) => {
  const { t } = useTranslation();
  const options = cloneDeep(props.options);

  if (props.allowNone) {
    options.unshift({
      label: t(i18nKeys.general.none),
      value: undefined,
    });
  }

  return (
    <label className={styles.container}>
      <span>{props.label}</span>
      <Select
        selectedOption={props.selectedOption || null}
        placeholder={props.placeholder}
        options={options}
        onChange={props.onChange}
        data-testid={props['data-testid']}
      />
    </label>
  );
};
